(function ($) {
  $(function () {
    $('li.menu-item-has-children:has(button.submenu-expand)').click(function (e) {
      
      if ($(e.target).closest('ul.sub-menu').length > 0) {
        return;
      }
      e.preventDefault();
      $(this).children('.submenu-expand').toggleClass('rotate');
      $(this).children('ul.sub-menu').slideToggle('slow');
    });
  });
})(jQuery);
